import { render, staticRenderFns } from "./View2.vue?vue&type=template&id=6aa0c1dc"
import script from "./View2.vue?vue&type=script&lang=js"
export * from "./View2.vue?vue&type=script&lang=js"
import style0 from "./View2.vue?vue&type=style&index=0&id=6aa0c1dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports